import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
//import logo from "../../images/logo.svg";
import "./styles.scss";
import { Link, useHistory, useLocation } from "react-router-dom";

import Auth from "../../config/auth";
import storeId from "../../config/storeId";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchUserEmailRegistration } from "../../redux/actions/authentication";

import { CLIENT_ID, BASE_URL } from "../../redux/constants";

//import GoogleLogin from "react-google-login";
import Axios from "axios";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import isEmpty from "../../utils/isEmpty";

const Register = (props) => {
  const store = storeId();
  let history = useHistory();
  let location = useLocation();
  const { buttonLabel, className } = props;
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    cpassword: "",
    store_id: Auth.getStore(),
  });
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const userData = {
      ...form,
      verifyPassword: form.cpassword,
    };
    try {
      const response = await Axios.post(
        `${BASE_URL}/users/register/email`,
        userData
      );
      if (response.data.hasError) {
        // setErrors({ ...errors, ...props.user.errors.errors, yesError: true });
        setForm({ ...form, password: "" });
        NotificationManager.error(response.data.errors.message);
        setLoading(false);
      } else {
        const { user, token } = response.data.data;
        Auth.setToken(token, user);
        console.log(response.data.data);

        history.push(location.pathname);
        //setErrors({ ...errors, yesError: false });
        setForm({
          ...form,
          name: "",
          email: "",
          phone: "",
          password: "",
          cpassword: "",
        });
        setLoading(false);
        NotificationManager.success(response.data.message);
        toggle();
      }
    } catch (error) {
      console.log(error);
    }
  }

  // function handleSubmit(e) {
  //   e.preventDefault();
  //   setLoading(true);
  //   const userData = {
  //     name: form.name,
  //     email: form.email,
  //     phone: form.phone,
  //     password: form.password,
  //     verifyPassword: form.cpassword,
  //     store_id: Auth.getStore(),
  //   };
  //   props.fetchUserEmailRegistration(userData);
  // }
  // useEffect(() => {
  //   setLoading(false);

  //   if (!isEmpty(props.user.user)) {
  //     const { user } = props.user;
  //     if (!user.hasError) {
  //       setState(user.data);
  //       NotificationManager.success(user.message);
  //       //history.push("/order");
  //       history.push("/");
  //       toggle();
  //       setErrors({ ...errors, yesError: false });
  //     }
  //   } else {
  //     if (props.user.errors.errors) {
  //       setErrors({ ...errors, ...props.user.errors.errors, yesError: true });
  //     }
  //   }
  // }, [props.user]);

  return (
    <div>
      <NotificationContainer />
      <Button className="login" size="sm" outline color="dark" onClick={toggle}>
        {buttonLabel}
      </Button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <NotificationContainer />
        <div className="justify-content-center">
          <ModalHeader toggle={toggle} className="text-center">
            <div className="login-header">{store}</div>
          </ModalHeader>
          <ModalBody>
            <form
              className="text-center p-3"
              method="post"
              onSubmit={handleSubmit}
            >

              <div className="form-group">
                <label htmlFor="exampleInputPassword1">Full name</label>
                <input
                  type="text"
                  name="fullname"
                  className="form-control login-input"
                  id="exampleInputPassword1"
                  autoFocus
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputPassword1">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  className="form-control login-input"
                  id="exampleInputPassword1"
                  autoFocus
                  required
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email address</label>
                <input
                  type="email"
                  name="email"
                  className="form-control login-input"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  autoFocus
                  required
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputPassword1">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control login-input"
                  id="exampleInputPassword1"
                  autoFocus
                  required
                  value={form.password}
                  onChange={(e) =>
                    setForm({ ...form, password: e.target.value })
                  }
                />
              </div>
              <div class="form-group">
                <label htmlFor="exampleInputEmail1">Confirm password</label>
                <input
                  type="password"
                  class="form-control  login-input"
                  name="cpassword"
                  value={form.cpassword}
                  onChange={(e) =>
                    setForm({ ...form, cpassword: e.target.value })
                  }
                  required
                  autoFocus
                />
              </div>

              <div className="d-flex justify-content-between">
                <label>
                  <input type="checkbox" id="checkbox2" /> keep me Logged in
                </label>
                <Link>forgot password</Link>
              </div>

              <button
                type="submit"
                className="btn login-btn text-white"
                disabled={loading}
              >
                {loading ? "Loading..." : "Register"}
              </button>
            </form>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </div>
      </Modal>
    </div>
  );
};

Register.propTypes = {
  user: PropTypes.object.isRequired,
  fetchUserEmailRegistration: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.emailRegister,
});

const pageActions = { fetchUserEmailRegistration };

export default connect(mapStateToProps, pageActions)(Register);
